'use client';

import { Locale } from '@eos/shared-locale-utility/locale';
import { messages } from '@eos/shared-locale-utility/locales';
import { FC, PropsWithChildren } from 'react';
import { IntlProvider as ReactIntlProvider } from 'react-intl';

/**
 * Minimal IntlProvider for Event Portal
 * Provides locale context and translations from shared utility locale
 */
export const MinimalIntlProvider: FC<PropsWithChildren<{ locale: Locale }>> = ({
  children,
  locale,
}) => {
  return (
    <ReactIntlProvider
      locale={locale}
      messages={messages[locale]}
      defaultLocale="en-US"
    >
      {children}
    </ReactIntlProvider>
  );
};
